export default __webpack_public_path__ + "static/media/gallery-5-4.c8b9cf56.webp";